// extracted by mini-css-extract-plugin
export default {"innerWrapper":"kt-z","tooltipWrapper":"lt-z","icon":"mt-z","tooltip":"nt-z","content":"ot-z"};